export default __webpack_public_path__ + "static/media/arrow-left-flat.55b37be5.svg";